var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJapaneseFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "japanese-flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#cecece",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.8824,
    d: "M0.941 0.941h42.089v30.118h-42.089v-30.118z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bc002d",
    d: "M30.291 16.941c0 4.678-3.792 8.471-8.471 8.471s-8.471-3.792-8.471-8.471c0-4.678 3.792-8.471 8.471-8.471s8.471 3.792 8.471 8.471z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapaneseFlag);
export default __webpack_public_path__ + "static/media/japanese-flag.8789060b2d32b05ec48dfa5a1c516825.svg";
export { ForwardRef as ReactComponent };